export * from './create-coach-mutation.gql';
export * from './get-coach-query.gql';
export * from './update-coach-mutation.gql';
export * from './delete-coach-image-mutation.gql';
